module.exports = __webpack_public_path__ + "bid.png?0386949d069a2e85a9705071ce052026";